import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { ApplicationContextStore } from '../application-context/application-context.store';

export const applicationContextReadyGuard: CanActivateFn = () => {
    const store = inject(ApplicationContextStore);
    if (store.isReady()) return true;
    return toObservable(store.isReady).pipe(
        filter((ready) => ready),
        map(() => true),
        take(1),
    );
};
